exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1IZdx{width:100vw;max-width:100vw!important;margin:0!important;background:none!important;padding:0!important;-webkit-box-shadow:none!important;box-shadow:none!important}._3TxDz{background-color:rgba(0,0,0,.8)!important}.wDvQI{color:#fff;margin-top:10px}._2yc1n{outline:none!important}.XkWL9{fill:#fff}._3Q6jR{position:relative;height:90vh;overflow-y:scroll;scroll-behavior:smooth}._2k9MY{max-width:800px;margin:0 auto;padding:0 10px;color:#fff;font-size:10px}._2TiLJ{display:block;width:100%;max-width:800px;margin:5px auto}.u5mut{width:100px;margin:5px 0;border:1px solid #fff;border-radius:3px}", ""]);

// exports
exports.locals = {
	"root": "_1IZdx",
	"overlay": "_3TxDz",
	"heading": "wDvQI",
	"close": "_2yc1n",
	"closeIcon": "XkWL9",
	"images": "_3Q6jR",
	"alt": "_2k9MY",
	"image": "_2TiLJ",
	"thumbnail": "u5mut"
};